import * as React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { TRANSACTION_STATUS } from '../../common/constants';
import { updateTransactionStatus } from '../../libs/GsmpiApi';

export default function CancelButton(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const transactionId = queryParams.get('transactionId') ? queryParams.get('transactionId') : props.transactionId;

  CancelButton.propTypes = {
    className: PropTypes.string,
    transactionId: PropTypes.string
  };

  const handleCancelClick = () => {
    const cancelPayload = {
      payment: {
        status: TRANSACTION_STATUS.CANCELED,
        reason: 'cancelledByUser'
      },
      timestamp: new Date().getTime()
    };

    updateTransactionStatus(transactionId, cancelPayload)
      .then(() => {
        navigate('/gsmpi-web/cancel');
      })
      .catch(() => {
        navigate('/gsmpi-web/error');
      });
  };

  return(
    <button type="button" className={props.className} onClick={handleCancelClick}>
      {t('pay.gsmpi.main.button1')}
    </button>
  );
}